import { PropTypes } from 'prop-types';
import styles from './styles.module.scss';
import { Container, Row, Col } from 'react-bootstrap';

const CardContent = (props) => {
  const { color, children, type, ...other } = props;

  return (
    <div className={`${styles.wrapper} ${styles[`wrapper--${color}`]} ${styles[`wrapper--${type}`]}`}>
      <Container fluid>
        <Row>
          <Col {...other} className={styles.content}>
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CardContent.defaultProps = {
  color: 'white'
};

CardContent.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node
};

export default CardContent;
